import type { IconProps } from "./IconProps";

export const AngleSmallDownIcon = ({ height = 16, width = 16, color = "black" }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 5.98891L9.05996 10.5916C8.77924 10.8531 8.39855 11 8.0016 11C7.60466 11 7.22396 10.8531 6.94324 10.5916L2 5.98612L3.05836 5L8.0016 9.60271L12.9416 5L14 5.98891Z" fill={color} />
    </svg>
);
